import { useId } from "react";
import logo from "../../assets/logo-nobg.png";

/**
 * The app's one loading indicator: a gold gradient ring (the same motif
 * as the splash screen's expanding ring) with the SC mark resting at
 * its center on larger sizes. Used for page-level loads, data fetches,
 * and — via GlobalFetchIndicator — background query activity, so
 * "loading" always reads the same way everywhere in the app.
 */
export default function SCSpinner({ size = 56, showMark = true, className = "" }) {
  const gradientId = useId();
  const showLogo = showMark && size >= 40;
  const strokeWidth = Math.max(2, size * 0.06);
  const r = 25 - strokeWidth / 2 - 1;
  const circumference = 2 * Math.PI * r;

  return (
    <div
      role="status"
      aria-label="Loading"
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox="0 0 50 50" className="animate-spin-smooth">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f8e3a1" />
            <stop offset="50%" stopColor="#b8860b" />
            <stop offset="100%" stopColor="#6b4e0c" />
          </linearGradient>
        </defs>
        <circle cx="25" cy="25" r={r} fill="none" stroke="#b8860b" strokeOpacity="0.15" strokeWidth={strokeWidth} />
        <circle
          cx="25"
          cy="25"
          r={r}
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${circumference * 0.32} ${circumference}`}
        />
      </svg>
      {showLogo && (
        <img
          src={logo}
          alt=""
          className="absolute inset-0 m-auto object-contain"
          style={{ width: size * 0.74, height: size * 0.74 }}
        />
      )}
    </div>
  );
}
